<template>
  <g v-if="handlesOn" :transform="`matrix(1,0,0,1, ${element.x + 20}, ${element.y +20})`">
    <rect
      :height="element.h"
      :width="element.w"
      fill="none"
      opacity="0.5"
      stroke="#000"
      stroke-width="1"
    />
    <circle
      cx="0"
      cy="0"
      fill="#fff"
      r="4"
      stroke="#000"
      stroke-width="1"
      @mousedown="$emit('resize', $event, 'nwse')"
    />
    <circle
      :cx="element.w"
      cy="0"
      fill="#fff"
      r="4"
      stroke="#000"
      stroke-width="1"
      @mousedown="$emit('resize', $event, 'nesw')"
    />
    <circle
      :cy="element.h"
      cx="0"
      fill="#fff"
      r="4"
      stroke="#000"
      stroke-width="1"
      @mousedown="$emit('resize', $event, 'nesw')"
    />
    <circle
      :cx="element.w"
      :cy="element.h"
      fill="#fff"
      r="4"
      stroke="#000"
      stroke-width="1"
      @mousedown="$emit('resize', $event, 'nwse')"
    />
    <circle
      :cx="element.w / 2"
      cy="0"
      fill="#fff"
      r="4"
      stroke="#000"
      stroke-width="1"
      @mousedown="$emit('resize', $event, 'ns')"
    />
    <circle
      :cx="element.w / 2"
      :cy="element.h"
      fill="#fff"
      r="4"
      stroke="#000"
      stroke-width="1"
      @mousedown="$emit('resize', $event, 'ns')"
    />
    <circle
      :cy="element.h / 2"
      cx="0"
      fill="#fff"
      r="4"
      stroke="#000"
      stroke-width="1"
      @mousedown="$emit('resize', $event, 'ew')"
    />
    <circle
      :cx="element.w"
      :cy="element.h / 2"
      fill="#fff"
      r="4"
      stroke="#000"
      stroke-width="1"
      @mousedown="$emit('resize', $event, 'ew')"
    />
  </g>
</template>

<script lang="ts" setup>
defineProps<{
  handlesOn: boolean;
  element: {
    x: number;
    y: number;
    w: number;
    h: number;
  };
}>();

defineEmits<{
  resize: [MouseEvent, string];
}>();
</script>